import { app } from "./";
import { getDatabase, ref, get } from "firebase/database";

const database = getDatabase(app);

export const read = (path: string): Promise<any> =>
    new Promise(async (resolve, reject) => {
        try {
            const snapshot = await get(ref(database, path));
            resolve(snapshot.val());
        } catch (error) {
            reject(error);
        }
    });
